import { SelectButton } from "primereact/selectbutton";
import React from "react";
import { Checkbox } from "react-inputs-validation";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Textbox, Textarea } from "react-inputs-validation";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  Row,
} from "reactstrap";
import { FetchValidarPlacasPolizaCarrito } from "../../../redux/actions/ACarritoProductos";
import { setCorreo } from "../../../redux/actions/aCotizacion";
import "../../../styles/estilos.css";
import { urlObtenerSiniestralidad } from "../api/urls";
import { httpClient } from "../../../api/httpClient";


class ValoresCotizacionRenovacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      correo: "",
      validate: false,
      tieneError: true,
      visibleAlert: true,
      terminosHabilitado:
        this.props.paso === "confirmacion-cotizacion" ? false : true,
      height: window.innerHeight,
      claseDivFix: "",
      claseDivFixPlan: "",
      selectedItem: this.props.planSeleccionado,
      total: null
    };
    //this.handleScroll = this.handleScroll.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss() {
    this.setState({ visibleAlert: false });
  }

  editarForm = (formEditado) => {
    this.setState({ formEditado });
  };

  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasContraseniaActualError,
      hasContraseniaNuevaError,
      hasConfirmacionError,
    } = this.state;

    if (
      !hasContraseniaActualError ||
      !hasContraseniaNuevaError ||
      !hasConfirmacionError
    ) {
      this.handleOnClick();
    }
  }

  onClick = async (event) => {
    //console.log("Entre a evento onCLik")
    event.preventDefault();

    let total = {
      prima_neta_anual_full_cobertura: "0.00",
      super_bancos_Full_Cobertura: "0.00",
      seguro_campesino_Full_Cobertura: "0.00",
      derecho_emision_Full_Cobertura: "0.00",
      primaTotal_Full_Cobertura: "0.00",
      iva_Full_Cobertura: "0.00",
      totalImpuestos: "0.00",
    };

    if (this.props.paso === "datos-cotizacion") {

      let { detalleCarrito, placa } = this.props;
      var valorTotalAux = detalleCarrito.productosCarrito.valorTotal
      if (valorTotalAux) {

        console.log('productosCarrito', detalleCarrito.productosCarrito)
        valorTotalAux.primaTotal_Full_Cobertura = valorTotalAux.totalcarrito

        let arrayProductos = detalleCarrito.productosCarrito.carProductos;
        let productoObtenido = arrayProductos.filter(
          (producto) => producto.datosProducto.placa === placa
        );
        productoObtenido = productoObtenido[0];

        total =
          valorTotalAux ? valorTotalAux :
            productoObtenido === undefined
              ? Object.keys(detalleCarrito.productosCarrito).length === 0
                ? "0.00"
                : arrayProductos[0].totales
              : productoObtenido.totales;

      }
    }
    if (this.props.paso === "datos-cotizacion") {










      this.props.metodo(total.prima_neta_anual_full_cobertura);
      //console.log("EnALGOOO")
    } else if (this.props.paso === "resumen-cotizacion") {
      let idCarrito = '';

      if (this.props.detalleCarrito.productosCarrito.idCarrito)
        idCarrito = this.props.detalleCarrito.productosCarrito.idCarrito;

      //Preparar JSON para validar la informacion
      const datosValidarPlacas = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        idcarrito: idCarrito,
      };
      await this.props.fetchValidarPlacasPolizaCarrito(datosValidarPlacas, true);


      this.props.setLoadingSiniestralidad(true)
      let siniestralidad = await this.validarSiniestralidad()
      this.props.setLoadingSiniestralidad(false)

      if (
        siniestralidad.transaccion == false
      ) {

        this.props.setErrorSinistralidad(true, siniestralidad.mensaje)





      } else {

        this.props.setErrorSinistralidad(false, '')

      }






      //console.log("VALIDAR PLACAS", this.props.detalleCarrito.SetValidarPlacasPoliza);
      if (this.props.detalleCarrito.SetValidarPlacasPoliza === true) {
        this.props.metodo(siniestralidad.transaccion, total, siniestralidad.carRecalcularValoresTasaRenovacion);
        //  this.props.metodo(siniestralidad.transaccion, total, false);
      }
    } else if (this.props.paso === "confirmacion-cotizacion") {
      this.props.metodo(event);
    } else if (this.props.paso === "final-cotizacion") {
      this.props.metodo(event);
    } else if (this.props.paso === "final-cotizacion-error") {
      this.props.metodo(event);
    }
  };
  onClickReintentarPago = (event) => {
    //console.log("Entre a evento onCLik Reintentar pago")
    event.preventDefault();
    this.props.metodo2(event);
  };

  onChangeCorreo = (event) => {
    event.preventDefault();
    this.setState({
      correo: event.target.value,
    });
    this.props.setCorreo(event.target.value);
  };

  onClickDescargar = (event) => {
    event.preventDefault();
    this.props.metodoDescargar(event);
  };

  async validarSiniestralidad() {
    try {
      let idCarrito = '';

      if (this.props.detalleCarrito.productosCarrito.idCarrito)
        idCarrito = this.props.detalleCarrito.productosCarrito.idCarrito;
      console.log('Siniestralidad:', this.props.detalleCarrito);

      const url = `${urlObtenerSiniestralidad}&idCarrito=${idCarrito}`;
      const data = await httpClient.get(url);

      return data;
    } catch (error) {
      console.error('Error en validarSiniestralidad:', error);
      return {
        transaccion: false,
        mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
      };
    }
  }


  onClickEnviar = (event) => {

    event.preventDefault();

    this.setState({ validate: !this.state.validate })

    if (!this.state.tieneError) {
      this.props.metodoEnviar(event);
    }


  };
  /* Eventos Scroll */
  handleScroll() {
    const windowHeight =
      "innerHeight" in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = windowHeight + window.pageYOffset;
    if (this.props.paso === "resumen-cotizacion") {
      //console.log("total this.props.detalleCarrito.productosCarrito.carProductos.length",this.props.detalleCarrito.productosCarrito.carProductos.length)
      if (
        this.props.detalleCarrito &&
        this.props.detalleCarrito.productosCarrito &&
        this.props.detalleCarrito.productosCarrito.carProductos &&
        this.props.detalleCarrito.productosCarrito.carProductos.length > 1
      ) {
        if (windowBottom >= docHeight - 300) {
          this.setState({
            claseDivFix:
              "flex-row div-flotante fix-botton-totales-resumen-multi",
            claseDivFixPlan:
              "flex-row div-flotante-km fix-botton-totales-resumen-multi",
          });
        } else {
          this.setState({
            claseDivFix: "flex-row div-flotante",
            claseDivFixPlan: "flex-row div-flotante-km",
          });
        }
      } else {
        if (windowBottom >= docHeight - 300) {
          this.setState({
            claseDivFix: "flex-row div-flotante fix-botton-totales-resumen",
            claseDivFixPlan:
              "flex-row div-flotante-km fix-botton-totales-resumen",
          });
        } else {
          this.setState({
            claseDivFix: "flex-row div-flotante",
            claseDivFixPlan: "flex-row div-flotante-km",
          });
        }
      }
    } else {
      if (windowBottom >= docHeight - 120) {
        this.setState({
          claseDivFix: "flex-row div-flotante fix-botton-totales",
          claseDivFixPlan: "flex-row div-flotante-km fix-botton-totales",
        });
        //console.log("Scroll TOP");
      } else {
        this.setState({
          claseDivFix: "flex-row div-flotante",
          claseDivFixPlan: "flex-row div-flotante-km",
        });
      }
    }
  }

  componentDidMount() {
    //  window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    //  window.removeEventListener("scroll", this.handleScroll);
  }

  itemTemplate = (option) => {
    //console.log(option);
    return (
      <div
        className='container w-100'
        style={{
          width: "100%",
          border: "",
          borderRadius: "4px",
          lineHeight: "15px",
        }}
        key={option.codigo}>
        <small style={{ fontSize: "10px" }}>{option.plan}</small>
        <br />
        <strong style={{ fontSize: "11px" }}>${option.valor}</strong>
        <br />
        <small style={{ fontSize: "10px" }}>
          Vigencia: {option.vigenciaDias}
        </small>
      </div>
    );
  };

  onChangeItem = ({ value }) => {
    //value=== plan
    this.props.onSelect(value);
  };

  render() {
    let textoBoton = "CONTINUAR";
    let { detalleCarrito, formEditado, valorTotal, placa } = this.props;
    const {
      correo,
      terminosHabilitado,
      claseDivFix,
      claseDivFixPlan,
    } = this.state;
    //console.log("Cambiando estado boton ", formEditado, Object.keys(detalleCarrito.productosCarrito).length, placa)
    //const{formEditado}=this.state;
    let total = {
      prima_neta_anual_full_cobertura: "0.00",
      super_bancos_Full_Cobertura: "0.00",
      seguro_campesino_Full_Cobertura: "0.00",
      derecho_emision_Full_Cobertura: "0.00",
      primaTotal_Full_Cobertura: "0.00",
      iva_Full_Cobertura: "0.00",
      totalImpuestos: "0.00",
    };

    if (this.props.paso === "datos-cotizacion") {
      var valorTotalAux = detalleCarrito.productosCarrito.valorTotal
      if (valorTotalAux) {

        console.log('productosCarrito', detalleCarrito.productosCarrito)
        valorTotalAux.primaTotal_Full_Cobertura = valorTotalAux.totalcarrito

        let arrayProductos = detalleCarrito.productosCarrito.carProductos;
        let productoObtenido = arrayProductos.filter(
          (producto) => producto.datosProducto.placa === placa
        );
        productoObtenido = productoObtenido[0];

        total =
          valorTotalAux ? valorTotalAux :
            productoObtenido === undefined
              ? Object.keys(detalleCarrito.productosCarrito).length === 0
                ? "0.00"
                : arrayProductos[0].totales
              : productoObtenido.totales;

      }

    } else {
      total = valorTotal;
    }

    //console.log(total)
    if (total === "0.00") {
      total = {
        prima_neta_anual_full_cobertura: "0.00",
        super_bancos_Full_Cobertura: "0.00",
        seguro_campesino_Full_Cobertura: "0.00",
        derecho_emision_Full_Cobertura: "0.00",
        primaTotal_Full_Cobertura: "0.00",
        iva_Full_Cobertura: "0.00",
        totalImpuestos: "0.00",
        totalCarrito: "0.00",
      };
    }

    const { msgValidarPlacas } = this.props.detalleCarrito;
    //console.log("THIS", msgValidarPlacas);

    if (
      this.props.paso === "confirmacion-cotizacion" &&
      this.props.dataUsuario.usu_tipo_usuario === "cliente"
    ) {
      textoBoton = "PAGAR";
    }

    return (
      <div className={''}>
        <div>
          <Card style={{ width: "99%" }}>
            {((this.props.codigoProductoEspecial &&
              this.props.codeProductoEspecial !== "KilometrosConsumidos" &&
              this.props.planes != null &&
              this.props.planes.length > 0) || (this.props.recompra)) && (
                <CardHeader style={{ position: "" }}>
                  <strong>Selecciona tu Plan Ideal</strong>
                </CardHeader>
              )}
            <CardBody>
              <div>
                {((this.props.codigoProductoEspecial &&
                  this.props.codeProductoEspecial !== "KilometrosConsumidos" &&
                  this.props.planes != null &&
                  this.props.planes.length > 0) || (this.props.recompra)) && (
                    <div>
                      <div class=''>
                        <Form style={{ width: "99%" }}>
                          {this.props.planes != null && (
                            <SelectButton
                              value={this.props.planSeleccionado}
                              options={this.props.planes}
                              onChange={this.onChangeItem}
                              optionLabel='codigo'
                              //optionValue="codigo"
                              itemTemplate={this.itemTemplate}
                              className='vertically w-100 my-3'
                              dataKey='codigo'
                            />
                          )}
                        </Form>
                      </div>
                    </div>
                  )}
              </div>
              <div>
                {(this.props.paso === "resumen-cotizacion" ||
                  this.props.codeProductoEspecial === "KilometrosConsumidos" ||
                  this.props.codeProductoEspecial === "comparador" ||
                  this.props.codeProductoEspecial === "externo" ||
                  this.props.codeProductoEspecial === "pits" ||
                  (!this.props.codigoProductoEspecial &&
                    !this.props.ProductoEspecial)) && (
                    <div>
                      <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>
                      <Row>
                        <Col lg={6} md={6} sm={6} xs={6}>
                          <h5>Prima Neta</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={6}>
                          <h5>${total.prima_neta_anual_full_cobertura}</h5>
                        </Col>
                      </Row>
                      <Row>
                        <div id='container-imp'>
                          <div className='accordion-imp'>
                            <input type='checkbox' id='tm' />
                            <label htmlFor='tm' className='accordionitem'>
                              <Row>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5
                                    title={
                                      "Presiona click para ver/ocultar el detalle impuestos"
                                    }>
                                    Impuestos{" "}
                                    <i
                                      className='fa fa-info-circle'
                                      aria-hidden='true'
                                    />
                                  </h5>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5>${total.totalImpuestos}</h5>
                                </Col>
                              </Row>
                            </label>
                            <div className='hiddentext ocultar'>
                              <Row>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5>IVA</h5>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5>${total.iva_Full_Cobertura}</h5>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5>Super bancos 3.5 %</h5>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5>${total.super_bancos_Full_Cobertura}</h5>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5>Seguro Campesino</h5>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5>
                                    ${total.seguro_campesino_Full_Cobertura}
                                  </h5>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5>Derechos de Emisión</h5>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <h5>${total.derecho_emision_Full_Cobertura}</h5>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Row>
                      <Row>
                        <Col lg={6} md={6} sm={6} xs={6}>
                          <p />
                          <h5 style={{ fontWeight: "bold" }}>Prima Total</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={6}>
                          <p />
                          <h5 style={{ fontWeight: "bold" }}>
                            $
                            {this.props.paso === "datos-cotizacion"
                              ? total.primaTotal_Full_Cobertura
                              : total.totalcarrito}
                          </h5>
                        </Col>
                      </Row>

                      <hr />
                    </div>
                  )}
                {this.props.paso === "resumen-cotizacion" && (
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      {

                        (this.props.paso === "resumen-cotizacion")
                        &&
                        !this.props.recalcular &&
                        (

                          <Button
                            className={
                              formEditado
                                ? "btn btn-primary btn-purple fe-pulse"
                                : "btn btn-primary"
                            }
                            onClick={this.onClick}
                            style={{ display: "block", margin: "auto" }}
                          >
                            <i
                              className="fa fa-chevron-circle-right"
                              aria-hidden="true"
                            />{" "}
                            {formEditado
                              ? "ACTUALIZAR"
                              : this.props.dataUsuario !== undefined
                                ? this.props.dataUsuario.usu_tipo_usuario ===
                                  "cilente"
                                  ? "INICIAR EMISIÓN"
                                  : "INICIAR EMISIÓN"
                                : ""}
                          </Button>
                        )}

                      {

                        (this.props.paso === "resumen-cotizacion")
                        &&
                        this.props.recalcular &&
                        (

                          <Button
                            className={
                              formEditado
                                ? "btn btn-primary btn-purple fe-pulse"
                                : "btn btn-primary"
                            }
                            onClick={() => { this.props.metodoRecalcular() }}
                            style={{ display: "block", margin: "auto" }}
                          >
                            <i
                              className="fa fa-refresh"
                              aria-hidden="true"
                            />{" "}
                            RECALCULAR
                          </Button>
                        )}
                      <br></br>
                    </Col>

                    {/* <Col lg={12} md={12} sm={12} xs={12}>
                      <Button
                        className='btn btn-detail-white'
                        onClick={this.onClickDescargar}>
                        <i
                          className='fa fa-cloud-download'
                          aria-hidden='true'
                        />{" "}
                        DESCARGAR COTIZACIÓN
                      </Button>
                      <br></br>
                    </Col> */}
                    <Col lg={12} md={12} sm={12} xs={12}>
                      {(this.props.datosCotizacion.descargaOk &&
                      this.props.codeProductoEspecial !== "externo2" 
                      



                      ) && (
                          <a
                            className='btn btn-detail-white'
                            href={this.props.datosCotizacion.datosDescarga.urlPdf}
                            target='_blank'
                            rel='noopener noreferrer'>
                            <i
                              className='fa fa-cloud-download'
                              aria-hidden='true'
                            />{" "}
                            DESCARGAR COTIZACIÓN
                          </a>
                        )}
                    </Col>
                  </Row>
                )}

                {this.props.paso === "resumen-cotizacion" &&
                  this.props.dataUsuario !== undefined &&
                  this.props.codeProductoEspecial !== "externo2"  &&
                   this.props.codeProductoEspecial !== "externo2"  &&
                  (this.props.dataUsuario.usu_tipo_usuario === "broker-user" ||
                    this.props.dataUsuario.usu_tipo_usuario === "canal-user" ||
                    this.props.dataUsuario.usu_tipo_usuario === "servicio-cliente-user" ||
                    this.props.dataUsuario.usu_tipo_usuario === "asesor-user" ||
                    this.props.dataUsuario.usu_tipo_usuario ===
                    "admin-user") &&

                (
                    <Row>
                      <Col lg={8} md={12} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="input"
                          value={this.props.email}
                          name="correo"
                          id="correo"
                          classNameInput={"form-control"}
                          onChange={(correo, e) => {
                            this.props.setEmail(correo)
                          }}
                          placeholder="Por favor ingrese el correo" // Optional.[String].Default: "".
                          validate={this.state.validate}
                          validationCallback={(res) => {

                            console.log('resfs', res)

                            //setHasCorreoError(res)
                            this.setState({ validate: !res, tieneError: res })



                          }} // Optional.[Func].Default: none. Return the validation result.
                          onBlur={(e) => {
                            // this.setState({ blur: true });
                            //console.log("BLUUUR");
                          }}
                          validationOption={{
                            name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            regMsg: "Por favor ingrese un correo válido",
                            msgOnError: "Por favor ingrese un correo válido", // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                      <Col lg={4} md={12} sm={12} xs={12}>
                        <Button
                          className='btn btn-detail-white'
                          onClick={this.onClickEnviar}>
                          <i className='fa fa-envelope' aria-hidden='true' />{" "}
                          ENVIAR
                        </Button>
                      </Col>

                      {this.props.datosCotizacion.envioOK && (
                        <Alert
                          color='success'
                          isOpen={this.state.visibleAlert}
                          toggle={this.onDismiss}>
                          <center>
                            <p>
                              Se ha enviado correctamente la cotización al
                              correo electrónico ingresado.
                            </p>
                          </center>
                        </Alert>
                      )}
                    </Row>
                  )}

                {this.props.paso === "final-cotizacion" && (
                  <Button
                    className={"btn btn-primary"}
                    onClick={this.onClick}
                    style={{ display: "block", margin: "auto" }}>
                    <i
                      className='fa fa-chevron-circle-right'
                      aria-hidden='true'
                    />{" "}
                    {"NUEVA COTIZACIÓN"}
                  </Button>
                )}
                {this.props.paso === "final-cotizacion-error" && (
                  <div>
                    <Button
                      className={"btn btn-primary"}
                      onClick={this.onClick}
                      style={{ display: "block", margin: "auto" }}>
                      <i
                        className='fa fa-chevron-circle-right'
                        aria-hidden='true'
                      />{" "}
                      {"NUEVA COTIZACIÓN"}
                    </Button>
                    <br></br>
                    <Button
                      className={"btn btn-primary btn-purple"}
                      onClick={this.onClickReintentarPago}
                      style={{ display: "block", margin: "auto" }}>
                      <i
                        className='fa fa-chevron-circle-right'
                        aria-hidden='true'
                      />{" "}
                      {"REINTENTAR PAGO"}
                    </Button>
                  </div>
                )}
                {msgValidarPlacas !== undefined && msgValidarPlacas !== "" && (
                  <Alert color='danger'>
                    <center>
                      <p>{msgValidarPlacas}</p>
                    </center>
                  </Alert>
                )}

                {this.props.paso === "confirmacion-cotizacion" && (
                  /*Agregar aceptar terminos y condiciones del sitio */
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={21}>
                      <table style={{ margin: "auto" }}>
                        <tr>
                          <td>
                            <Checkbox
                              id={"terminosycondiciones"} // Optional.[String].Default: "".  Input ID.
                              name={"terminosycondiciones"} // Optional.[String].Default: "". Input name
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              checked={terminosHabilitado} // Required.[Bool].Default: false.
                              onChange={(terminosHabilitado, e) => {
                                this.setState({
                                  terminosHabilitado,
                                });
                                //console.log("terminosHabilitado", terminosHabilitado);
                              }} // Required.[Func].Default: () => {}. Will return the value.
                              validationOption={{
                                name: "terminosycondiciones", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              }}
                            />
                          </td>
                          <td>
                            <a
                              title='Ver Términos y Condiciones'
                              href={this.props.dataUsuario.disclaimerUrl}
                              target='_blank'>
                              <h6 style={{ marginTop: "0.4em" }} className="btn-color-main">
                                {" "}
                                Aceptar Términos y Condiciones{" "}
                              </h6>
                            </a>
                          </td>
                        </tr>
                      </table>
                    </Col>
                    <hr />
                  </Row>
                )}

                {this.props.paso !== "resumen-cotizacion" &&
                  this.props.paso !== "final-cotizacion" &&
                  this.props.paso !== "final-cotizacion-error" && (
                    <Button
                      className={
                        formEditado
                          ? "btn btn-primary btn-purple fe-pulse"
                          : "btn btn-primary"
                      }
                      onClick={this.onClick}
                      style={{ display: "block", margin: "auto" }}
                      disabled={!terminosHabilitado || this.props.desactivarBoton}>
                      <i
                        className='fa fa-chevron-circle-right'
                        aria-hidden='true'
                      />{" "}
                      {formEditado ? "ACTUALIZAR" : textoBoton}
                    </Button>
                  )}
              </div>

              {/* <Row>
                <Col lg={6} md={6} sm={6} xs={6}>
                  <p />
                  <h5 style={{ fontWeight: "bold" }}>Prima Total 9</h5>
                </Col>
                <Col lg={6} md={6} sm={6} xs={6}>
                  <p />
                  <h5 style={{ fontWeight: "bold" }}>
                    $
                    {this.props.paso === "datos-cotizacion"
                      ? total.primaTotal_Full_Cobertura
                      : total.totalcarrito}
                  </h5>
                </Col>
              </Row>
              <hr /> */}

              {/* {this.props.paso === "resumen-cotizacion" && (
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <Button
                      className={
                        formEditado
                          ? "btn btn-primary btn-purple fe-pulse"
                          : "btn btn-primary"
                      }
                      onClick={this.onClick}
                      style={{ display: "block", margin: "auto" }}>
                      <i
                        className='fa fa-chevron-circle-right'
                        aria-hidden='true'
                      />{" "}
                      {formEditado
                        ? "ACTUALIZAR"
                        : this.props.dataUsuario !== undefined
                        ? this.props.dataUsuario.usu_tipo_usuario === "cilente"
                          ? " INICIAR EMISIÓN"
                          : " INICIAR EMISIÓN"
                        : ""}
                    </Button>
                    <br></br>
                  </Col>

                  <Col lg={12} md={12} sm={12} xs={12}>
                    <Button
                      className='btn btn-detail-white'
                      onClick={this.onClickDescargar}>
                      <i className='fa fa-cloud-download' aria-hidden='true' />{" "}
                      DESCARGAR COTIZACIÓN
                    </Button>
                    <br></br>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    {this.props.datosCotizacion.descargaOk && (
                      <a
                        href={this.props.datosCotizacion.datosDescarga.urlPdf}
                        target='_blank'
                        rel='noopener noreferrer'>
                        {" "}
                        Click para descargar
                      </a>
                    )}
                  </Col>
                </Row>
              )} */}

              {/* {this.props.paso === "resumen-cotizacion" &&
                this.props.dataUsuario !== undefined &&
                (this.props.dataUsuario.usu_tipo_usuario === "broker-user" ||
                  this.props.dataUsuario.usu_tipo_usuario === "canal-user" ||
                  this.props.dataUsuario.usu_tipo_usuario === "asesor-user" ||
                  this.props.dataUsuario.usu_tipo_usuario === "admin-user") && (
                  <Row>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <input
                        className='form-control'
                        placeholder='Por favor ingrese el correo'
                        value={correo}
                        onChange={this.onChangeCorreo}></input>
                    </Col>
                    <Col lg={4} md={12} sm={12} xs={12}>
                      <Button
                        className='btn btn-detail-white'
                        onClick={this.onClickEnviar}>
                        <i className='fa fa-trash-o' aria-hidden='true' />{" "}
                        ENVIAR
                      </Button>
                    </Col>
                    {this.props.datosCotizacion.envioOK && (
                      <Alert
                        color='success'
                        isOpen={this.state.visibleAlert}
                        toggle={this.onDismiss}>
                        <center>
                          <p>
                            Se ha enviado correctamente la cotización al correo
                            electrónico ingresado.
                          </p>
                        </center>
                      </Alert>
                    )}
                  </Row>
                )} */}

              {/* {this.props.paso === "final-cotizacion" && (
                <Button
                  className={"btn btn-primary"}
                  onClick={this.onClick}
                  style={{ display: "block", margin: "auto" }}>
                  <i
                    className='fa fa-chevron-circle-right'
                    aria-hidden='true'
                  />{" "}
                  {"NUEVA COTIZACIÓN"}
                </Button>
              )}
              {this.props.paso === "final-cotizacion-error" && (
                <div>
                  <Button
                    className={"btn btn-primary"}
                    onClick={this.onClick}
                    style={{ display: "block", margin: "auto" }}>
                    <i
                      className='fa fa-chevron-circle-right'
                      aria-hidden='true'
                    />{" "}
                    {"NUEVA COTIZACIÓN"}
                  </Button>
                  <br></br>
                  <Button
                    className={"btn btn-primary btn-purple"}
                    onClick={this.onClickReintentarPago}
                    style={{ display: "block", margin: "auto" }}>
                    <i
                      className='fa fa-chevron-circle-right'
                      aria-hidden='true'
                    />{" "}
                    {"REINTENTAR PAGO"}
                  </Button>
                </div>
              )} */}
              {/* {msgValidarPlacas !== undefined && msgValidarPlacas !== "" && (
                <Alert color='danger'>
                  <center>
                    <p>{msgValidarPlacas}</p>
                  </center>
                </Alert>
              )} */}
              {/* 
              {this.props.paso === "confirmacion-cotizacion" && (
                //Agregar aceptar terminos y condiciones del sitio 
                <Row>
                  <Col lg={12} md={12} sm={12} xs={21}>
                    <table style={{ margin: "auto" }}>
                      <tr>
                        <td>
                          <Checkbox
                            id={"terminosycondiciones"} // Optional.[String].Default: "".  Input ID.
                            name={"terminosycondiciones"} // Optional.[String].Default: "". Input name
                            onBlur={() => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            checked={terminosHabilitado} // Required.[Bool].Default: false.
                            onChange={(terminosHabilitado, e) => {
                              this.setState({
                                terminosHabilitado,
                              });
                              //console.log("terminosHabilitado", terminosHabilitado);
                            }} // Required.[Func].Default: () => {}. Will return the value.
                            validationOption={{
                              name: "terminosycondiciones", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            }}
                          />
                        </td>
                        <td>
                          <a
                            title='Ver Términos y Condiciones'
                            href={this.props.dataUsuario.disclaimerUrl}
                            target='_blank'>
                            <h6 style={{ marginTop: "0.4em" }}>
                              {" "}
                              Aceptar Términos y Condiciones{" "}
                            </h6>
                          </a>
                        </td>
                      </tr>
                    </table>
                  </Col>
                  <hr />
                </Row>
              )} */}

              {/* {this.props.paso !== "resumen-cotizacion" &&
                this.props.paso !== "final-cotizacion" &&
                this.props.paso !== "final-cotizacion-error" && (
                  <Button
                    className={
                      formEditado
                        ? "btn btn-primary btn-purple fe-pulse"
                        : "btn btn-primary"
                    }
                    onClick={this.onClick}
                    style={{ display: "block", margin: "auto" }}
                    disabled={!terminosHabilitado}>
                    <i
                      className='fa fa-chevron-circle-right'
                      aria-hidden='true'
                    />{" 9"}
                    {formEditado ? "ACTUALIZAR" : textoBoton}
                  </Button>
                )} */}
            </CardBody>
          </Card>
          {this.props.errorProducto && (
            <Alert color="warning">
              <center>
                <p>
                  {this.props.mensajeErrorProducto}
                </p>
              </center>
            </Alert>
          )}

          {this.props.errorSiniestralidad && (
            <Alert color="danger">
              <center>
                <p>
                  {this.props.mensajeErrorSiniestralidad}
                </p>
              </center>
            </Alert>
          )}

          {this.props.tieneErrorPrimaMinima && (
            <Alert color="danger">
              <center>
                <p>
                  {this.props.mensajeErrorPrimaMinima}
                </p>
              </center>
            </Alert>
          )}

          {(this.props.recalcular && !this.props.recalculado) && (
            <Alert color="info">
              <center>
                <p>{"Se han asignado nuevos valores. Por favor, proceda con el recálculo"}</p>
              </center>
            </Alert>
          )}

           {this.props.recalcularContratante && (
            <Alert color="info">
              <center>
                <p>{"Se han asignado nuevos valores. Por favor, proceda con el recálculo regresando a la pantalla de resumen"}</p>
              </center>
            </Alert>
          )}

          {this.props.recalculado && (
            <Alert color="success">
              <center>
                <p>{"El recálculo se ha completado con los nuevos valores"}</p>
              </center>
            </Alert>
          )}
        </div>

        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  detalleCarrito: state.dataProductoCarrito,
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosCotizacion: state.datosCotizacion,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setCorreo: (data) => dispatch(setCorreo(data)),
    fetchValidarPlacasPolizaCarrito: (datos, esRenovacion) =>
      dispatch(FetchValidarPlacasPolizaCarrito(datos, esRenovacion)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ValoresCotizacionRenovacion)
);

/*



  <FormGroup check>
                            {this.props.planes != null &&
                              this.props.planes.map((plan) => {
                                return (
                                  <div style={{ height: "4em" }}>
                                    <CustomInput
                                      type="radio"
                                      key={Math.random()}
                                      id={plan.codigo}
                                      name="customRadio"
                                      style={{
                                        fontSize: 14,
                                        fontWeight: "bold",
                                      }}
                                      label={plan.plan + " - $" + plan.valor}
                                      onClick={() => this.props.onSelect(plan)}
                                      defaultChecked={
                                        this.props.planSeleccionado != null &&
                                        plan.plan ===
                                          this.props.planSeleccionado.plan
                                          ? true
                                          : false
                                      }
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vigencia:{" "}
                                    {plan.vigenciaDias}
                                    <hr />
                                  </div>
                                );
                              })}
                          </FormGroup>





*/
